module.exports = "<div class=\"interest\" [class.active]=\"model[field]==true || model[field]=='true' || model[field]=='elec'\" [class.twoLines]=\"field=='interestedAccessory'\" (click)=\"save()\">\n    <div>{{placeholder}}</div>\n    <i *ngIf=\"model[field]=='elec' || (placeholder=='Flyer' && model[field]==true)\" class=\"fa fa-battery-half\" aria-hidden=\"true\"></i>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/home/components/interest/interest.component.html
// module id = 730
// module chunks = 1